import { types, flow, getSnapshot } from 'mobx-state-tree';
import {makeRequest, errorResponse, url} from 'js/services/Network';
import analytics from 'js/services/Analytics';
import PaymentLink from '../types/PaymentLink';
import AnonymousId from 'js/services/AnonymousId';

export default types
  .model('EditItemForm', {
    isSaving: false,
    error: types.maybeNull(types.string),
    wasSubmitted: false,
    alias: types.string,
    isLoading: false,
    isLoaded: false,
    item: types.optional(PaymentLink, {}),
    itemBeforeEditing: types.optional(PaymentLink, {}),
  })
  .views(self => ({
    get hasError() {
      return !!self.error;
    },
    get hasAddressError() {
      return self.isLoaded && (!self.item.address || !self.item.address.hasAddress) && self.wasSubmitted;
    },
  }))
  .actions(self => ({
    afterCreate() {
      self.load();
    },

    load: flow(function* load() {
      let response = null;

      if (!self.isLoading) {
        self.isLoaded = false;
        self.isLoading = true;

        try {
          response = yield makeRequest('edit-payment-link-data', self);
          //analytics.page('PLA_link edit payment link by seller');
          self.item = response.data;
          self.itemBeforeEditing = response.data;
          self.isLoaded = true;
        } catch (error) {
          self.error = errorResponse(error);
        }

        self.isLoading = false;
      }

      return response;
    }),

    save: flow(function* save() {
      let response = null;

      if (!self.isSaving) {
        self.isSaving = true;
        self.error = null;

        try {
          response = yield makeRequest('payment-link-save', self.item, {
            anonymous_id: AnonymousId,
            ...getSnapshot(self.item),
          });

          // analytics.track('PLA_link edited by seller', {
          //   picture: self.item.image.url,
          //   price: self.item.price,
          // });

          analytics.track('Offer Edited', {
            'Previous Values': self.itemBeforeEditing,
            'Current Values': self.item,
            'Payment Link': self.item.checkout_url,
            'Event Initiated by': 'seller'
          });
        } catch (error) {
          self.error = errorResponse(error);
        }

        self.isSaving = false;
      }

      return response;
    }),

    onUpload(image_url) {
      self.item.image.url = image_url;
    },

    clearError() {
      self.error = null;
      return self;
    },
    setError(message) {
      self.error = message;
      return self;
    },
    setWasSubmitted(wasSubmitted = true) {
      self.wasSubmitted = wasSubmitted;
      return self;
    },
  }));
